import { useParams } from '@tanstack/react-router';
import { Button } from '../ui/button';
import { getLogos } from '../../services/direct';
import { useQuery } from '@tanstack/react-query';
import FacilityLogo from '../FacilityLogo';
import { LanguagePicker } from '../ui/language-picker';
import { useTranslation } from 'react-i18next';

type TLeftSide = {
  isStartClaimProcess?: boolean;
  toggleStartClaimProcess?: () => void;
};

const LeftSide = ({
  isStartClaimProcess,
  toggleStartClaimProcess,
}: TLeftSide) => {
  const params = useParams({ strict: false });
  const { t } = useTranslation();

  const refundId = params.refundId;

  const getLogosQuery = useQuery({
    queryKey: ['logos', refundId],
    queryFn: () => getLogos(refundId),
  });

  return (
    <div className='flex h-full flex-col justify-between md:p-10 md:pr-20'>
      <div>
        <div className='flex h-[100px] w-full flex-row items-center justify-center gap-4 border-b border-gray-200 px-8 py-4 md:justify-start md:border-none'>
          <FacilityLogo
            facility_logo={getLogosQuery.data?.facility_logo}
            business_unit_logo={getLogosQuery.data?.business_unit_logo}
          />
        </div>
        {!isStartClaimProcess && (
          <div className='flex justify-end self-end p-1 md:hidden'>
            <LanguagePicker />
          </div>
        )}
      </div>

      <div className='flex flex-col gap-2 p-10 md:p-0'>
        <h2 className='mb-2 text-4xl font-bold text-balance text-primary-600 capitalize md:normal-case'>
          {t('You are just a few steps away from claiming your funds.')}
        </h2>
        <p className='text-muted-foreground'>{t('please.proceed')}</p>
      </div>
      <div className='hidden md:block'>
        <footer>
          <p className='text-muted-foreground'>
            {t('Powered by')}{' '}
            <a
              href='https://www.clientpaydirect.com/'
              target='_blank'
              className='font-bold'
            >
              <img
                src='/logo.svg'
                alt='Client Pay Direct'
                className='inline h-6'
              />
            </a>
          </p>
        </footer>
      </div>
      {!isStartClaimProcess && toggleStartClaimProcess && (
        <div className='p-10 md:hidden'>
          <Button
            variant='success'
            className='w-full'
            onClick={toggleStartClaimProcess}
          >
            {t('Start claiming process')}
          </Button>
        </div>
      )}
    </div>
  );
};

export default LeftSide;
